import { CommonService } from './../Services/common.service';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { NotificationService } from './notification.service';
import { AuthService } from '../Services/auth.service';
@Component({
  selector: "app-inbox",
  templateUrl: "./inbox.component.html",
  standalone:false,
  styleUrls: ["./inbox.component.scss"],
})
export class InboxComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  selectedMessages: string = "";
  messagesTypelist;
  selectedProduct: string = "";
  productList;
  selectedItem ;
  IndoxMessageList: [] = [];

  constructor(
    private _router: Router,
    private location: Location,
    private translate: TranslateService,
    private notification: NotificationService,
    private auth: AuthService,
    private CommonService: CommonService
  ) {}
  showModal(num) {
    this.modalObservable.next(num);
  }

  async ngOnInit(): Promise<void> {
    this.messagesTypelist = [
      {
        value: "Inquire",
        displayValue: "Inquire",
      },
      {
        value: "Request",
        displayValue: "Request",
      },
      {
        value: "Complaint",
        displayValue: "Complaint",
      },
      {
        value: "Feedback",
        displayValue: "Feedback",
      },
      {
        value: "Other",
        displayValue: "Other",
      },
    ];

    this.productList = [
      {
        value: "Account",
        displayValue: "Account",
      },
      {
        value: "Card",
        displayValue: "Card",
      },
      {
        value: "Deposit",
        displayValue: "Deposit",
      },
      {
        value: "Loan",
        displayValue: "Loan",
      },
      {
        value: "Digital Services",
        displayValue: "Digital Services",
      },
      {
        value: "Other Services",
        displayValue: "Other Services",
      },
    ];
    this.auth.accessToken = await this.CommonService.Get("token");
    await this.CommonService.presentLoading();

    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data?.response?.code == 1) {
        this.CommonService.hideLoading();
       await this.GetInboxMessages();
      
      } else {
        await this.CommonService.hideLoading();
        this.CommonService.ParseErrorAlert("", "", this._router, data);
      }
    });
  }

 async GetInboxMessages()  {
    await this.CommonService.presentLoading();
    this.notification
    .GetInboxMessages({}, this.auth.accessToken)
    .then(async (data: any) => {
      if (data?.response?.code == 1) {
        this.IndoxMessageList = data?.response?.content;
        await this.CommonService.hideLoading();
      } else {
        await this.CommonService.hideLoading();
      }
    });
  }

  onMessagesChange(event) {
    this.selectedMessages = event.displayValue;
  }

  onProductChange(event) {
    this.selectedProduct = event.displayValue;
  }

  activeTab: number = 1;
  changeTab(e) {
    this.activeTab = e;
  }

  activeNoti: number = null;
  changeNoti(item) {
    this.activeNoti = item?.id;
    this.selectedItem = item;

    if(!item.isRead){
      this.CommonService.presentLoading();

      this.notification.InboxMessageRead({InboxId:item?.id},this.auth.accessToken).then((data:any)=>{

        if(data?.response?.code==1){

          this.CommonService.hideLoading();
  
        }else{
  
          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert('','',this._router,data);

        }
  
  
  
      })

    }
   
    



  }

  activeMessage: number = 0;
  changeMessage(e) {
    this.activeMessage = e;
  }
  async deleteMessage(item){

    await this.CommonService.presentLoading();
    this.notification.DeleteInboxMessage({"InboxId":item?.id},this.auth.accessToken).then(async (data:any)=>{

      if(data?.response?.code==1){
        await this.CommonService.hideLoading();
        await this.GetInboxMessages();



      }else{
        await this.CommonService.hideLoading();
        this.CommonService.ParseErrorAlert('','',this._router,data);


      }

    })
    console.log('Deleteitem',item)




  }
}
